<template>
  <div class="_ipbookingform global__scrollcustom">
    <div class="row _ipbookingform__wrapper _ipbookingform__loader" v-if="isLoadingRfq || isLoadingContract || isLoadingBidRfq || isLoadingBidContract || isLoadingPrice || authIsLoading">
      <half-circle-spinner
        :animation-duration="750"
        :size="100"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <form @submit.prevent="handleSubmit" action="" method="">
          <InfoHeader
            :shipmentType="shipmentType"
            :bookingData="bookingData"
          ></InfoHeader>
        <div class="_ipbookingform__wrapper">
          <BookingForm
            :shipmentType="shipmentType"
            :shipmentMethod="shipmentMethod"
            :bookingData="bookingData"
            :errorBookingFrom="errorBookingFrom"
            :missingDataAlert="missingDataAlert"
            :mandatoryAlert="mandatoryAlert"
            @mandatoryBillAddress='mandatoryBillAddress'
            @getBookingForm="getBookingForm"
            @checkErrorBookingForm="checkErrorBookingForm"
            @getToastValue="getToastValue"
          ></BookingForm>
        </div>
        <template v-if="!isLoadingRfq">
          <div class="_navbar__bottom d-flex" :class="`${rfqData ? rfqData.service_head === 'AIR' ? 'global__bc_purple' : rfqData.service_head === 'LAND' ? 'global__bc_deepgreen' : 'global__bc_blue' : 'global__bc_blue'}`">
            <div class="_navbar__bottom--content d-flex justify-content-end">
              <div class="w-full mt-5">
                <button class="_btn rounded-lg" type="submit" name="button">Place Order</button>
              </div>
              <!-- <div class="row m-0 d-flex justify-content-end"> -->
                <!-- <div class="row _totalcost"> -->
                  <!-- <h4> ESTIMATE TOTAL COST*</h4>
                  <p>{{`${shipmentType === 'instant-price' && bookingData.bookData ? bookingData.bookData.orderPriceTotal : bookingData.bidData && bookingData.bidData.bid}` | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}</p> -->
                <!-- </div> -->
              <!-- </div> -->
              <!-- <div class="row _bottomtext"> -->
                <!-- <p>
                *The price quoted is based on the item description you provided. If the actual dimensions differ when picked up,  
                  you will be charged accordingly.
                </p> -->
              <!-- </div> -->
            </div>
          </div>

        </template>
      </form>
    </div>
  </div>
</template>

<script>
import InfoHeader from '@/components/bookingForm/InfoHeader'
import BookingForm from '@/components/bookingForm/BookingForm'
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import * as moment from 'moment'

export default {
  name: 'bookingform',
  components: {
    InfoHeader,
    BookingForm,
    HalfCircleSpinner
  },
  data () {
    return {
      shipmentType: this.$route.params.type,
      billingAddressMandatoy: false,
      mandatoryAlert: false,
      rfqId: '',
      contractId: '',
      iqId: '',
      bidId: '',
      bookingData: {},
      shipmentMethod: '', // export or import
      form: {
        shipper_name: '',
        shipper_comp: '',
        shipper_address: '',
        shipper_phone: '',
        shipper_phonecode: '',
        shipper_email: '',
        shipper_zip_code: '',
        shipper_company_tax_id: '',
        consignee_name: '',
        consignee_comp: '',
        consignee_address: '',
        consignee_phone: '',
        consignee_phonecode: '',
        consignee_zip_code: '',
        consignee_company_tax_id: '',
        notifiy_party_comp: '',
        notifiy_party_name: '',
        notifiy_party_address: '',
        notifiy_party_phone: '',
        notifiy_party_phonecode: '',
        notifiy_party_zip_code: '',
        notifiy_party_company_tax_id: '',
        notifiy_party_same_consignee: 1,
        shipper_notes: '',
        consignee_email: '',
        id_customer_address: '',
      },
      quote: {},
      query: {
        form: {}
      },
      payloadLog: {
        featureName: 'CREATE INSTANT PRICE',
        featureStep: 7,
        stepName: 'Booking Instant Price',
        featureProcess: {
          status: 'success',
          data: {}
        }
      },
      validBookingFromShipper: false,
      validBookingFromConsignee: false,
      validBookingFromPhoneCodeConsignee: false,
      validBookingFromPhoneCodeNotify: false,
      errorBookingFrom: false,
      missingDataAlert: [],
      toastValue: '',
      dataBillingGlobal: null
    }
  },
  mounted () {
    this.init()
    this.fetchBillingAddress()
  },
  methods: {
    async init () {
      if (this.shipmentType === 'rfq') {
        this.rfqId = this.$route.params.id
        this.bidId = this.$route.params.bidId
        this.fetchRfqById(this.rfqId)
        this.fetchBidRfq(this.rfqId)
      } else if (this.shipmentType === 'contract') {
        this.contractId = this.$route.params.id
        this.bidId = this.$route.params.bidId
        this.fetchContractById(this.contractId)
        this.fetchBidContract(this.contractId)
      } else if (this.shipmentType === 'iq') {
        this.iqId = this.$route.params.id
        this.fetchIqById(this.iqId)
      } else if (this.shipmentType === 'instant-price') {
        const instantPriceData = JSON.parse(localStorage.getItem('instantPriceData'))
        this.bookingData.inputData = instantPriceData.form.originCountry === 'IDN' ? 'export' : 'import'
        await this.$store.dispatch('instantprice/POST_INSTANT_PRICE', instantPriceData)
        this.initInstantPrice()
      }
    },
    initInstantPrice () {
      const inputData = this.bookingData.inputData
      const bookData = this.bookingData.bookData

      this.setForm(inputData.form)
      this.setQuery(inputData)
      this.setQuote(inputData.form, bookData)

      Object.assign(this.bookingData.bookData, this.quote)
      this.quote = this.bookingData.bookData
    },
    getBookingForm (data) {
      if (data) {
        Object.assign(this.form, data)
        // localStorage.setItem('bookingFormData', JSON.stringify(data))
      }
    },
    mandatoryBillAddress (data) {
      this.billingAddressMandatoy = data
    },
    fetchRfqById (id) {
      this.$store.dispatch('rfq/FETCH_RFQ_BY_ID', id)
    },
    fetchContractById (id) {
      this.$store.dispatch('contract/FETCH_CONTRACT_BY_ID', id)
    },
    fetchBidRfq (id) {
      this.$store.dispatch('rfq/FETCH_BID', id)
    },
    fetchBidContract (id) {
      this.$store.dispatch('contract/FETCH_BID_CONTRACT', id)
    },
    fetchIqById (id) {
      this.$store.dispatch('instantQuote/FETCH_IQ_BY_ID', id)
    },
    checkInputBookingFormShipper () {
      if (this.form.shipper_name && this.form.shipper_comp &&
        this.form.shipper_address && this.form.shipper_phone && this.form.shipper_zip_code
      ) {
        this.validBookingFromShipper = true
        this.missingDataAlert = this.missingDataAlert.filter((el) => el !== 'shipper')
      } else {
        this.errorBookingFrom = true
        this.validBookingFromShipper = false
        this.missingDataAlert.push('shipper')
      }
    },
    checkInputBookingFormCosignee () {
      if (this.form.consignee_name && this.form.consignee_comp &&
        this.form.consignee_address && this.form.consignee_phone && this.form.consignee_zip_code
      ) {
        this.validBookingFromConsignee = true
        this.missingDataAlert = this.missingDataAlert.filter((el) => el !== 'consignee')
      } else {
        this.errorBookingFrom = true
        this.validBookingFromConsignee = false
        this.missingDataAlert.push('consignee')
      }
    },
    checkBookingFormConsigneePhoneCode () {
      if (this.form.consignee_phonecode) {
        this.validBookingFromPhoneCodeConsignee = true
        this.missingDataAlert = this.missingDataAlert.filter((el) => el !== 'consignee_phonecode')
      } else {
        this.validBookingFromPhoneCodeConsignee = false
        this.missingDataAlert.push('consignee_phonecode')
      }
    },
    checkBookingFormPhoneCode () {
      if (this.form.notifiy_party_phonecode) {
        this.validBookingFromPhoneCodeNotify = true
        this.missingDataAlert = this.missingDataAlert.filter((el) => el !== 'notify_phonecode')
      } else {
        this.validBookingFromPhoneCodeNotify = false
        this.missingDataAlert.push('notify_phonecode')
      }
    },
    checkErrorBookingForm (data) {
      this.errorBookingFrom = data
    },
    setBookType (data) {
      let bookType = ''
      const destinationCountry = this.shipmentData === 'instant-price' ? data.destination_country : data.country_to
      if (this.auth) {
        if (destinationCountry === 'IDN' || this.auth.companyHeadQuarter === destinationCountry) {
          bookType = 'import'
        } else {
          bookType = 'export'
        }
      }
      return bookType
    },
    setForm (shipmentData) {
      if (this.shipmentType !== 'iq') {
        this.form.commodities_class = this.shipmentType === 'instant-price' ? shipmentData.commoditiesClass : shipmentData.product_class
        this.form.goodsValue = this.shipmentType === 'instant-price' ? shipmentData.goodsValue : shipmentData.total_price
        this.form.commodities_hscode = this.shipmentType === 'instant-price' ? shipmentData.commoditiesHSCode : shipmentData.hs_code
        this.form.commodities_product = this.shipmentType === 'instant-price' ? shipmentData.commoditiesProduct : shipmentData.description
        this.form.status_shipment = this.shipmentType === 'rfq' ? 1 : this.shipmentType === 'contract' ? 2 : 0
        this.form.incoterms = this.shipmentType === 'instant-price' ? 'FOB' : shipmentData.incoterms
        this.form.shipment = this.shipmentType === 'instant-price' ? '' : shipmentData.optiontp
        this.form.pickup_address = this.shipmentType === 'instant-price' ? '' : shipmentData.pickup_address
        this.form.delivery_address = this.shipmentType === 'instant-price' ? '' : shipmentData.delivery_address
        this.form.commodities_type = this.shipmentType === 'instant-price' ? shipmentData.productType : shipmentData.product_type
        this.form.packingList = this.shipmentType === 'instant-price' ? '' : shipmentData.packing_list
        this.form.satuan = shipmentData.satuan
        this.form.book_type = this.setBookType(shipmentData)
        this.form.book_price_currency_code = 'USD'
        this.form.temperature = 0
      } else {
        this.form.commodities_class = shipmentData.details.productDetails.type
        this.form.commodities_product = shipmentData.details.productDetails.commodities
        this.form.commodities_hscode = shipmentData.details.productDetails.hsCode
        this.form.status_shipment = 3
        this.form.incoterms = shipmentData.details.addressDetails.incoterm
        this.form.shipment = shipmentData.bannerInfo.shipmentService
        this.form.satuan = JSON.parse(shipmentData.details.shipmentType.packingList)[0].satuan
        this.form.book_price_currency_code = 'USD'
        this.form.po_number = shipmentData.details.productDetails.poNumber
        this.form.packingList = shipmentData.details.shipmentType.packingList
        this.form.reference_number = shipmentData.bannerInfo.requestNumber
        this.form.note_for_merchant = shipmentData.details.others.remark
        this.form.warehouseStatus = shipmentData.details.others.additionalOptions.warehouse
        this.form.volume = shipmentData.details.shipmentType.volume
        this.form.pickup_address = shipmentData.details.addressDetails.originAddress ? shipmentData.details.addressDetails.originAddress : ''
        this.form.delivery_address = shipmentData.details.addressDetails.destinationAddress ? shipmentData.details.addressDetails.destinationAddress : ''
      }
      if (this.shipmentType === 'rfq') {
        this.form.satuan = shipmentData.shipment_type !== 'AIRCARGO' && shipmentData.shipment_type !== 'AIRCOURIER' && shipmentData.shipment_type !== 'SEALCL' ? 'container' : shipmentData.satuan
        this.form.note_for_merchant = shipmentData.note_for_merchant
        this.form.routeType = shipmentData.route_type
        if (shipmentData.shipment_type === 'BARGE' || shipmentData.shipment_type === 'LCT') {
          this.form.product_type = shipmentData.product_type
          this.form.loadDate = shipmentData.load_date
        }
      }

      if (this.shipmentType === 'contract') {
        this.form.contract_number = shipmentData.contract_number
        this.form.id_contract = shipmentData.id
        this.form.routeType = shipmentData.route_type
      }
      if (this.shipmentType !== 'contract' && this.shipmentType !== 'iq') {
        // execute if shipment type instant price or rfq
        this.form.po_number = shipmentData.po_number
      }
      if (this.shipmentType !== 'instant-price' && this.shipmentType !== 'iq') {
        // execute if shipment type rfq or contract
        this.form.reference_number = this.shipmentType === 'rfq' ? shipmentData.rfqnumber : shipmentData.contract_number
        this.form.termofpayment = this.shipmentType === 'rfq' ? shipmentData.payment_references : shipmentData.term_of_payment
      }
    },
    setQuote (shipmentData, bidData) {
      // quote
      // if shipment type instant price (shipmentData = bookingData.inputData.form) (bidData = bookingData.bookData)
      const True = true
      const False = false

      if (this.shipmentType !== 'iq') {
        this.quote.carrier_name = this.shipmentType === 'instant-price' ? bidData.orderShippingLine : bidData.shippingline
        this.quote.origin_country_code = this.shipmentType === 'instant-price' ? bidData.orderOriginCountryCode : shipmentData.country_from
        this.quote.origin_country = this.shipmentType === 'instant-price' ? bidData.orderOriginCountry : shipmentData.countryf
        this.quote.origin_city_code = this.shipmentType === 'instant-price' ? bidData.orderOriginCityCode : shipmentData.city_from
        this.quote.origin_city = this.shipmentType === 'instant-price' ? bidData.orderOriginCity : shipmentData.cityf
        this.quote.destination_country_code = this.shipmentType === 'instant-price' ? bidData.orderDestinationCountryCode : shipmentData.country_to
        this.quote.destination_country = this.shipmentType === 'instant-price' ? bidData.orderDestinationCountry : shipmentData.countryt
        this.quote.destination_city_code = this.shipmentType === 'instant-price' ? bidData.orderDestinationCityCode : shipmentData.city_to
        this.quote.destination_city = this.shipmentType === 'instant-price' ? bidData.orderDestinationCity : shipmentData.cityt
        this.quote.valid_until = this.shipmentType === 'instant-price' ? bidData.orderValidUntil : bidData.validdate
        this.quote.transittime_max = this.shipmentType === 'instant-price' ? bidData.orderTransittimeMax : bidData.estimatedaymax
        this.quote.transittime_min = this.shipmentType === 'instant-price' ? bidData.orderTransittimeMin : bidData.estimatedaymin
        this.quote.price_total = this.shipmentType === 'instant-price' ? bidData.orderPriceTotal : bidData.bid
        this.quote.freight_mode = this.shipmentType === 'instant-price' ? bidData.orderFreight : shipmentData.service_head
        this.quote.freight_type = this.shipmentType === 'instant-price' ? shipmentData.shipment_type : shipmentData.shipment_type
        this.quote.freight_sub_type = this.shipmentType === 'instant-price' ? shipmentData.freight_sub_type : shipmentData.service_sub_type
        this.quote.freight_direct = this.shipmentType === 'instant-price' ? bidData.orderDirect : false
        this.quote.price_currency_code = this.shipmentType === 'instant-price' ? bidData.orderPriceCurrencyCode : 'IDR'
        this.quote.vendor_id = this.shipmentType === 'instant-price' ? bidData.vendorId : bidData.id_merchant
        this.quote.vendor_name = this.shipmentType === 'rfq' ? bidData.c_comp ? bidData.c_comp.compname : bidData.c_comp : this.shipmentType === 'contract' ? bidData.compname : bidData.vendorName
        // this.quote.vendors = bidData.vendors
        this.quote.rfqStatus = this.shipmentType === 'rfq' ? True : False
        this.quote.container_option = shipmentData.container_option
        this.quote.optiontp = shipmentData.optiontp
      } else {
        const packingList = JSON.parse(shipmentData.details.shipmentType.packingList)
        this.quote.reqId = parseInt(this.$route.params.id)
        this.quote.carrier_name = shipmentData.details.others.carrierName
        this.quote.origin_country_code = shipmentData.details.addressDetails.originCountryCode
        this.quote.origin_country = shipmentData.details.addressDetails.originCountry
        this.quote.origin_city_code = shipmentData.details.addressDetails.originCityCode
        this.quote.origin_city = shipmentData.details.addressDetails.originCity
        this.quote.destination_country_code = shipmentData.details.addressDetails.destinationCountryCode
        this.quote.destination_country = shipmentData.details.addressDetails.destinationCountry
        this.quote.destination_city_code = shipmentData.details.addressDetails.destinationCityCode
        this.quote.destination_city = shipmentData.details.addressDetails.destinationCity
        this.quote.valid_until = shipmentData.validity.validUntil
        this.quote.freight_mode = shipmentData.details.shipmentType.freightMode
        this.quote.freight_type = shipmentData.details.shipmentType.shipmentType.split(' ')[0]
        this.quote.freight_direct = 0
        this.quote.price_currency_code = 'USD'
        this.quote.vendor_id = shipmentData.details.vendorInformation.vendorId
        this.quote.vendor_name = shipmentData.details.vendorInformation.vendorName
        this.quote.optiontp = shipmentData.bannerInfo.shipmentService
        this.quote.status_shipment = 3
        this.quote.reference_number = shipmentData.bannerInfo.requestNumber
        this.quote.hsCode = shipmentData.details.productDetails.hsCode
        this.quote.productType = shipmentData.details.productDetails.type
        this.quote.description = shipmentData.details.productDetails.commodities
        this.quote.incoterms = shipmentData.details.addressDetails.incoterm
        this.quote.dimension = JSON.stringify({ length: packingList[0].length || 0, width: packingList[0].width || 0, height: packingList[0].height || 0 })
        this.quote.un_number = shipmentData.details.productDetails.unNumber
        this.quote.weight_estimation = shipmentData.details.shipmentType.estimatedTotalWeight
      }
      if (this.shipmentType === 'rfq') {
        this.quote.rfqId = shipmentData.id
        this.quote.status_shipment = 1
        this.quote.statusBid = bidData.status_bid
      }
      if (this.shipmentType === 'contract') {
        this.quote.status_shipment = 2
        this.quote.id_contract = shipmentData.id
      }
      if (this.shipmentType !== 'instant-price' && this.shipmentType !== 'iq') {
        // execute if shipment type rfq or contract
        this.quote.reference_number = this.shipmentType === 'rfq' ? shipmentData.rfqnumber : shipmentData.contract_number
        this.quote.orderPriceCurrencyRate = 1
        this.quote.hsCode = shipmentData.hs_code
        this.quote.productType = shipmentData.description
        this.quote.goodsValue = shipmentData.total_price
        this.quote.description = shipmentData.description
        this.quote.incoterms = shipmentData.incoterms
        this.quote.dimension = shipmentData.dimension
        this.quote.bidId = bidData.id
        this.quote.pickup_address = shipmentData.pickup_address
        this.quote.delivery_address = shipmentData.delivery_address
        this.quote.orderPriceFreight = []
        this.quote.orderPriceDocument = []
        this.quote.orderPriceCustom = []
        this.quote.orderPriceTrucking = []
        this.quote.orderPriceInsurance = []
        this.quote.orderPriceOrigin = []
        this.quote.orderPriceDestination = []
      } 
      if (this.shipmentType !== 'contract' && this.shipmentType !== 'iq') {
        // execute if shipment type rfq or instant price
        this.quote.un_number = shipmentData.un_number
        this.quote.weight_estimation = shipmentData.weight_estimation === null || shipmentData.weight_estimation === undefined ? 0 : parseFloat(shipmentData.weight_estimation, 10)
        // this.quote.weight_estimation = 100
      }
    },
    setQuery (shipmentData) {
      if (this.shipmentType === 'instant-price') {
        // execute if shipment type instant price
        this.query = shipmentData
        if (this.query.shipmentLoad === 'aircargo') {
          this.query.form.loadsAIRCargo[0].weight = shipmentData.form.totalWeight
          this.query.form.loadsAIRCargo[0].volume = parseInt(shipmentData.form.totalVolumetric)
        } else if (this.query.shipmentLoad === 'aircourier') {
          this.query.form.loadsAIRCourier[0].weight = shipmentData.form.totalWeight
          this.query.form.loadsAIRCourier[0].volume = parseInt(shipmentData.form.totalVolumetric)
        } else if (this.query.shipmentLoad === 'lcl') {
          this.query.form.loadsLCL[0].weight = shipmentData.form.totalWeight
        }
      } else {
        // execute if shipment type is instant quote
        if (this.shipmentType === 'iq') {
          let load = ''
          if (shipmentData.bannerInfo.shipmentType && shipmentData.bannerInfo.shipmentType.includes('FCL')) {
            load = 'fcl'
          } else if (shipmentData.bannerInfo.shipmentType.includes('LCL')) {
            load = 'lcl'
          }

          this.query.shipmentLoad = load
          this.query.form.datePickup = shipmentData.details.addressDetails.shipmentDate !== '-' ? moment(shipmentData.details.addressDetails.shipmentDate).format('DD/MM/YY') : null
          this.query.form.originCity = shipmentData.details.addressDetails.originCityCode
          this.query.form.originCountry = shipmentData.details.addressDetails.originCountryCode
          this.query.form.destinationCity = shipmentData.details.addressDetails.destinationCityCode
          this.query.form.destinationCountry = shipmentData.details.addressDetails.destinationCountryCode
          this.query.form.customsInsurace = shipmentData.details.others.insurance === 0 ? 0 : 1
          this.query.form.insuranceId = shipmentData.details.others.insurance

          const packingList = JSON.parse(shipmentData.details.shipmentType.packingList)
          this.query.form.loadsLCL = [
            {
              qty: shipmentData.details.shipmentType.totalQuantity.toString(),
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: packingList[0].satuan,
              volume: shipmentData.details.shipmentType.volume,
              weight: shipmentData.details.shipmentType.estimatedTotalWeight.toFixed(3).toString(),
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCargo = [
            {
              qty: shipmentData.details.shipmentType.totalQuantity.toString(),
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: packingList[0].satuan,
              volume: shipmentData.details.shipmentType.volume,
              weight: shipmentData.details.shipmentType.estimatedTotalWeight.toFixed(3).toString(),
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCourier = [
            {
              qty: shipmentData.details.shipmentType.totalQuantity.toString(),
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: packingList[0].satuan,
              volume: shipmentData.details.shipmentType.volume,
              weight: shipmentData.details.shipmentType.estimatedTotalWeight.toFixed(3).toString(),
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsFCL = [
            {
              qty: shipmentData.details.shipmentType.totalQuantity,
              size: '',
              type: 'container',
              volume: shipmentData.details.shipmentType.volume,
              weight: shipmentData.details.shipmentType.estimatedTotalWeight.toFixed(3).toString()
            }
          ]
        } else {
          // execute if shipment type rfq or contract
          let load = ''
          if (shipmentData.shipment_type && shipmentData.shipment_type.includes('FCL')) {
            load = 'fcl'
          } else if (shipmentData.shipment_type === 'SEALCL') {
            load = 'lcl'
          } else {
            load = shipmentData.shipment_type
          }
          // query
          this.query.shipmentLoad = load
          // query form
          this.query.form.datePickup = shipmentData.cargo_readynes_date !== '-' ? moment(shipmentData.cargo_readynes_date).format('DD/MM/YY') : null
          this.query.form.originCity = shipmentData.city_from
          this.query.form.originCountry = shipmentData.country_from
          this.query.form.destinationCity = shipmentData.city_to
          this.query.form.destinationCountry = shipmentData.country_to
          this.query.form.customsClearanceOrigin = shipmentData.option_customs_clearance === 'true' ? 1 : 0
          this.query.form.customsClearanceDestination = shipmentData.option_customs_clearance_destination === 'true' ? 1 : 0
          this.query.form.estimateStorage = shipmentData.option_estimate_storage === 'true' ? 1 : 0
          this.query.form.customsInsurace = 1
          this.query.form.insuranceId = shipmentData.id_insurance
          this.query.form.loadsLCL = [
            {
              qty: `${this.shipmentType === 'rfq' ? shipmentData.estimatedqty : shipmentData.total_quantity}`,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: shipmentData.satuan,
              volume: shipmentData.estimateddimension,
              weight: `${this.shipmentType === 'rfq' ? shipmentData.estimatedweight : shipmentData.total_weight}`,
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCargo = [
            {
              qty: `${this.shipmentType === 'rfq' ? shipmentData.estimatedqty : shipmentData.total_quantity}`,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: shipmentData.satuan,
              volume: shipmentData.estimateddimension,
              weight: `${this.shipmentType === 'rfq' ? shipmentData.estimatedweight : shipmentData.total_weight}`,
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCourier = [
            {
              qty: `${this.shipmentType === 'rfq' ? shipmentData.estimatedqty : shipmentData.total_quantity}`,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: shipmentData.satuan,
              volume: shipmentData.estimateddimension,
              weight: `${this.shipmentType === 'rfq' ? shipmentData.estimatedweight : shipmentData.total_weight}`,
              weightUnit: 'kg'
            }
          ]
          if (this.shipmentType === 'rfq') {
            this.query.form.loadsFCL = [
              {
                qty: shipmentData.estimatedqty,
                size: '',
                type: 'container',
                volume: shipmentData.estimateddimension,
                weight: shipmentData.estimatedweight
              }
            ]
          }
          if (this.shipmentType === 'contract') {
            this.query.form.loadsFCL = [
              {
                qty: shipmentData.total_quantity,
                size: '',
                type: 'container',
                weight: 'standard'
              }
            ]
          }
        }
      }
    },
    async handleSubmit (e) {
      if ((this.rfqData && this.rfqData.service_head !== 'LAND') && this.billingAddressGlobal == null) {
        this.mandatoryAlert = true
      } else {
        this.mandatoryAlert = false
        this.form.id_customer_address = this.billingAddressGlobal ? this.billingAddressGlobal.id : ''
        this.checkInputBookingFormShipper()
        this.checkInputBookingFormCosignee()
        this.checkBookingFormConsigneePhoneCode()
        this.checkBookingFormPhoneCode()
        await this.$validator.validateAll().then((result) => {
          if (result && this.validBookingFromShipper && this.validBookingFromConsignee && this.validBookingFromPhoneCodeConsignee && this.validBookingFromPhoneCodeNotify) {
            this.missingDataAlert = []
            if (this.shipmentType !== 'instant-price') {
              const shipmentData = this.bookingData.shipmentData
              const bidData = this.bookingData.bidData
  
              this.setForm(shipmentData)
              this.setQuote(shipmentData, bidData)
              this.setQuery(shipmentData)
            } 
            const _form = {
              form: this.form,
              quote: this.quote,
              query: this.query
            }
            if (this.rfqData && this.rfqData.service_head === 'LAND') {
              _form.tms = { tmsDoNumber: this.rfqData.tms_do_number }
            }
            if (this.shipmentType === 'instant-price') {
              this.payloadLog.featureProcess.data = _form
              this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
              this.placeOrder(_form)
            } else {
              // POST_DATA_BOOK temporary save data booking form to vuex
              this.$store.dispatch('book/POST_DATA_BOOK', _form).then(() => {
                this.placeOrder(_form)
              })
            }
          }
        })
      }
    },
    placeOrder (data) {
      if (this.shipmentType === 'rfq' || this.shipmentType === 'iq') {
        this.$eventHub.$emit('dialog-requestlist-form', this.shipmentType)
      } else if (this.shipmentType === 'contract') {
        // Using Business Agreement
        // const contractNumber = this.form.contract_number.split('/').join('-')
        // const idContract = this.form.id_contract
        // this.$router.push({ name: 'ContractBusinessAgreement', params: {id_contract: idContract, contractNumber: contractNumber} })

        // Not using Business Agreement
        this.$eventHub.$emit('dialog-requestlist-contract-form')
      } else {
        this.$eventHub.$emit('dialog-instantprice-form', data)
      }
    },
    getToastValue (data) {
      this.toastValue = data
    },
    async fetchBillingAddress () {
      await this.$store.dispatch('address/GET_BILLING_ADDRESS')
    }
  },
  computed: {
    ...mapGetters({
      // fetch RFQ
      rfqData: 'rfq/item',
      isLoadingRfq: 'rfq/isLoading',
      errorRfq: 'rfq/error',
      // fetch contract
      contractData: 'contract/item',
      isLoadingContract: 'contract/isLoading',
      isErrorContract: 'contract/error',
      // fetch bid RFQ
      bidListRfq: 'rfq/bids',
      isLoadingBidRfq: 'rfq/isLoadingBid',
      errorBidRfq: 'rfq/isErrorLoadingBid',
      // fetch bid contract
      bidListContract: 'contract/bids',
      isLoadingBidContract: 'contract/isLoadingBid',
      errorBidContract: 'contract/errorBid',
      // Instant Quote
      iqData: 'instantQuote/iqDetail',
      isLoadingIqData: 'instantQuote/isLoadingIqDetail',
      errorIqData: 'instantQuote/errorIqDetail',
      // auth
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading',
      // book
      booked: 'book/items',
      isErrorBook: 'book/error',
      // fetch price in booking from
      price: 'instantprice/items',
      errorPrice: 'instantprice/error',
      isLoadingPrice: 'instantprice/isLoading',

      billingAddress: 'address/billingAddress',
      // global billing
      billingAddressGlobal: 'address/billingAddressGlobal'
    })
  },
  watch: {
    rfqData (data) {
      if (data) {
        this.bookingData.shipmentData = data
        this.shipmentMethod = data.country_from === 'IDN' ? 'export' : 'import'
      }
    },
    contractData (data) {
      if (data) {
        this.bookingData.shipmentData = data
        this.shipmentMethod = data.country_from === 'IDN' ? 'export' : 'import'
      }
    },
    iqData (data) {
      if (data) {
        this.bookingData.shipmentData = data
        this.shipmentMethod = data.country_from === 'IDN' ? 'export' : 'import'
      }
    },
    bidListRfq (data) {
      if (data) {
        const bidData = data.filter(item => (item.id === parseInt(this.bidId)))
        this.bookingData.bidData = bidData[0]
      }
    },
    bidListContract (data) {
      if (data) {
        const bidData = data.filter(item => (item.id === parseInt(this.bidId)))
        this.bookingData.bidData = bidData[0]
      }
    },
    price (data) {
      if (data) {
        const priceId = this.$route.params.id.split('-').join('_')
        const priceData = data.filter(item => (item.quoteId === priceId))
        priceData.map((item) => {
          Object.assign(item, { bookmarked: item.book })
        })
        this.bookingData.bookData = priceData[0]
      }
    },
    billingAddressGlobal (data) {
      this.dataBillingGlobal = data
    },
    billingAddress (data) {
      if (this.billingAddressGlobal) {
        this.dataBillingGlobal = this.billingAddressGlobal
      } else {
        this.$store.dispatch('address/BILLING_ADDRESS_GLOBAL', data)
      }
    },
    'form.shipper_name' (val) {
      if (val) {
        this.checkInputBookingFormShipper()
      }
    },
    'form.consignee_name' (val) {
      if (val) {
        this.checkInputBookingFormCosignee()
      }
    },
    'form.consignee_phonecode' (val) {
      if (val) {
        this.checkBookingFormConsigneePhoneCode()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/bookingForm/index.vue